<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">        
        <div class="row">
            <div class="col-12">

            <div class="form-group row">

            <div class="col-md-1">
                <yt-number-input-v3
                    name="txtRbrDela"                                 
                    [Label]="'DEOZARESENJEZAGO.RBRDELA.SINGULAR'" 
                    formControlName="RbrDela"
                    [FormatString]="'1.0-0'"
                >
                </yt-number-input-v3>
                <div class="form-error" *ngIf="submitted && fc.RbrDela.invalid">
                    <span *ngFor="let validation of errorMessages.RbrDela">
                        <span class="error-message" *ngIf="fc.RbrDela.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
            <!-- <div class="col-md-3">
                <yt-fw-date-picker-popup
                    id="OdDatuma"
                    name="dateOdDatuma"
                    formControlName="OdDatuma"
                    [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
                    [Label]="'DEOZARESENJEZAGO.ODDATUMA.SINGULAR'"
                    (OnDateSelected)="IzracunaBrojDana()"
                >
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
                    <span *ngFor="let validation of errorMessages.OdDatuma">
                        <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
            <div class="col-md-3">
                <yt-fw-date-picker-popup
                    name="dateDoDatuma"
                    formControlName="DoDatuma"
                    [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
                    [Label]="'DEOZARESENJEZAGO.DODATUMA.SINGULAR'">
                    (OnDateSelected)="IzracunaBrojDana()"
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
                    <span *ngFor="let validation of errorMessages.DoDatuma">
                        <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div> -->

            <div class="col-md-6">
                    <yt-fw-date-range-picker-popup
                    name="periodOdsustva"
                    [Label]="'DEOZARESENJEZAGO.ODDATUMA.SINGULAR'"
                    [LabelTo]="'DEOZARESENJEZAGO.DODATUMA.SINGULAR'"
                    formControlName="Period"
                    (OnDateSelected)="onDatumChange($event)"
                    [MinDate]={year:2000,month:1,day:1}
                    >
                    </yt-fw-date-range-picker-popup>  
            </div>

            <div class="col-md-2">
                <yt-input
                    [Type]="'NUMERIC'"
                    name="numberDana"
                    formControlName="Dana"
                    #focusElement
                    [MaxLength]="2"
                    [ngClass]="{'is-invalid': submitted && fc.Dana.invalid}"
                    [Label]="'DEOZARESENJEZAGO.DANA.SINGULAR'">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Dana.invalid">
                    <span *ngFor="let validation of errorMessages.Dana">
                        <span class="error-message" *ngIf="fc.Dana.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                        </span>
                    </span>
                </div>
            </div>

            <div class="col-md-3">
                <yt-fw-date-picker-popup
                    name="dateDatumPocetkaRada"
                    formControlName="DatumPocetkaRada"
                    [ngClass]="{'is-invalid' : submitted && fc.DatumPocetkaRada.invalid}"
                    [Label]="'DEOZARESENJEZAGO.DATUMPOCETKARADA.SINGULAR'">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.DatumPocetkaRada.invalid">
                    <span *ngFor="let validation of errorMessages.DatumPocetkaRada">
                        <span class="error-message" *ngIf="fc.DatumPocetkaRada.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
            </div>
        </div>
    </div>
    </form>
</div>